import { render, staticRenderFns } from "./OffersPolicies.vue?vue&type=template&id=08768e7c&scoped=true&"
import script from "./OffersPolicies.vue?vue&type=script&lang=js&"
export * from "./OffersPolicies.vue?vue&type=script&lang=js&"
import style0 from "./OffersPolicies.vue?vue&type=style&index=0&id=08768e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08768e7c",
  null
  
)

export default component.exports